import axios from "axios";
import { REACT_APP_API_DID_URL } from "../constants";
import { requestsFor } from "./headerService";
import { checkAPISuccess, manageServiceError } from "../utils/helpers";

const axiosInstance = axios.create({
    baseURL: `${REACT_APP_API_DID_URL}`,
});

export const didAxios = axiosInstance;

const requests = requestsFor(axiosInstance);

const path = {
    walletUserList: '/walletService/walletUserList',
    acceptedCredential: "/credential/GetAcceptedCredential",
    ignoredCredential: "/credential/GetIgnoredCredential",
    assignedCredential: "/credential/GetAssignedCredential",
}

export async function getWalletUserList({ payload, onSuccess, onFailure }) {
    try {
        const { data: response } = await requests.post(path.walletUserList, payload);
        if (checkAPISuccess(response)) {
            onSuccess && onSuccess(response);
        } else {
            onFailure && onFailure(response);
        }
    } catch (error) {
        manageServiceError(error, onFailure, "User List Failed");
    }
}

export async function getAcceptedCredential({ payload, onSuccess, onFailure }) {
    try {
        const { data: response } = await requests.post(path.acceptedCredential, payload);
        if (checkAPISuccess(response)) {
            onSuccess && onSuccess(response);
        } else {
            onFailure && onFailure(response);
        }
    } catch (error) {
        manageServiceError(error, onFailure, "Accepted Credential Failed");
    }
}

export async function getIgnoredCredential({ payload, onSuccess, onFailure }) {
    try {
        const { data: response } = await requests.post(path.ignoredCredential, payload);
        if (checkAPISuccess(response)) {
            onSuccess && onSuccess(response);
        } else {
            onFailure && onFailure(response);
        }
    } catch (error) {
        manageServiceError(error, onFailure, "Ignored Credential Failed");
    }
}

export async function getAssignedCredential({ payload, onSuccess, onFailure }) {
    try {
        const { data: response } = await requests.post(path.assignedCredential, payload);
        if (checkAPISuccess(response)) {
            onSuccess && onSuccess(response);
        } else {
            onFailure && onFailure(response);
        }
    } catch (error) {
        manageServiceError(error, onFailure, "Assigned Credential Failed");
    }
}